import { colorSets } from "../../const";

const renderAmazonColor = (alerts: any) => {
  if (alerts?.amazonShareBuyBox?.includes("Not Likely")) {
    return colorSets.danger;
  } else if (
    alerts?.amazonShareBuyBox?.includes("Never on Listing") ||
    alerts?.amazonShareBuyBox?.includes("Never on Buy Box")
  ) {
    return colorSets.success;
  } else if (alerts?.amazonShareBuyBox?.includes("Possibly")) {
    return colorSets.success;
  } else {
    return "inherit";
  }
};

const renderPrivateLabelColor = (alerts: any) => {
  if (alerts?.privateLabel?.includes("Maybe")) {
    return colorSets.warning;
  } else if (alerts?.privateLabel?.includes("No")) {
    return colorSets.success;
  } else {
    return "inherit";
  }
};

const renderIPAnalysisColor = (alerts: any) => {
  if (alerts?.ipAnalysis?.includes("is known to have IP issues")) {
    return colorSets.danger;
  } else if (alerts?.ipAnalysis?.includes("No known IP issues")) {
    return colorSets.success;
  } else {
    return "inherit";
  }
};

const renderSizeColor = (alerts: any) => {
  if (alerts?.size?.includes("Oversize - Small")) {
    return colorSets.warning;
  } else if (alerts?.size?.includes("Standard Size")) {
    return colorSets.success;
  } else if (alerts?.size?.includes("Over Size")) {
    return colorSets.danger;
  } else {
    return "inherit";
  }
};

export {
  renderAmazonColor,
  renderPrivateLabelColor,
  renderIPAnalysisColor,
  renderSizeColor,
};
